import { Button, Card, CardBody } from '../../design-system/primitives/index.js'

export default function KeepSavedCard({
  result,
  status = 'success',
  onRetry,
  onDismiss,
}) {
  if (status === 'failure') {
    return (
      <Card className="keep-saved keep-saved--failure" role="alert">
        <CardBody>
          <div className="keep-saved__icon" aria-hidden="true"><i className="fas fa-exclamation-circle" /></div>
          <div className="keep-saved__content">
            <p className="guest-home__eyebrow">YOUR ACCOUNT IS READY</p>
            <h2>Account created, but your kitchen didn’t attach</h2>
            <p>You’re logged in. This kitchen is still here — we can try saving it again.</p>
            <div className="keep-saved__actions">
              <Button variant="primary" onClick={onRetry}>Try saving again</Button>
              <a className="button secondary" href="mailto:support@martinisbythelake.com">Contact support</a>
            </div>
          </div>
        </CardBody>
      </Card>
    )
  }

  return (
    <Card className="keep-saved" role="status">
      <CardBody>
        <div className="keep-saved__icon" aria-hidden="true"><i className="fas fa-check" /></div>
        <div className="keep-saved__content">
          <p className="guest-home__eyebrow">SAVED TO YOUR ACCOUNT</p>
          <h2>Your kitchen is saved</h2>
          <ul>
            <li>{result?.pantryCount || 0} pantry items kept</li>
            <li>{result?.recipeCount || 0} recipes kept</li>
            <li>{result?.plannedDinners || 0} planned dinners kept</li>
            <li>{result?.shoppingItemCount || 0} shopping-list items kept</li>
            {result?.cookSessionCount ? <li>{result.cookSessionCount} time{result.cookSessionCount === 1 ? '' : 's'} you cooked, kept</li> : null}
            <li>{result?.preferencesSaved ? 'Preferences kept' : 'No preferences to move'}</li>
          </ul>
          {result?.conflictsSkipped ? (
            <p>{result.conflictsSkipped} existing account item{result.conflictsSkipped === 1 ? '' : 's'} kept unchanged.</p>
          ) : null}
        </div>
        <Button variant="ghost" onClick={onDismiss} aria-label="Dismiss saved kitchen summary">×</Button>
      </CardBody>
    </Card>
  )
}
